var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`height: ${_vm.isQiankun ? 'calc(100VH - 48px)' : '100VH'}`),attrs:{"id":"his_system"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }